import { Injectable } from '@angular/core';
import * as _ from "lodash";
import * as legend from "../../config/legend";
import * as series from "../../config/series";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as xAxis from "../../config/xAxis";
import * as yAxis from "../../config/yAxis";
import * as color from "../../config/colors";
import * as backgroundColor from "../../config/backgroundColor";
import * as datazoom from "../../config/datazoom";
import * as textStyle from "../../config/textStyle";
import { CommonService } from '../../service/common.service';

@Injectable({
  providedIn: 'root'
})
export class BasicPieService {

  constructor(
    private commonService: CommonService
  ) { }

  getDefaultOptionsOfBasicPieChart = () => {
    let style = this.commonService.changeFontSize()
    let defaultOptions = {
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getTooltipOfPieChart(style),
      series: series.getBasicPieChartSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return defaultOptions;
  }
  // 设置系列名
  changeSeriesName(chartOptions, string: string) {
    chartOptions.series[0].name = string;
  }
  // 更改饼图半径大小
  changeRadius(chartOptions, bcacPieChartRadius: string | number) {
    chartOptions.series[0].radius = bcacPieChartRadius;
  }

  changeCenter(chartOptions, bcacPieChartCenter: Array<string> | Array<number>) {
    chartOptions.series[0].center = bcacPieChartCenter
  }

  // 设置饼图数据
  changeChartData(ChartOptions, chartData: { name: string, value: string | number }[]) {
    ChartOptions.series[0].data = chartData;
  }

  // 设置toolbox显示
  changeToolboxShow(chartOptions, show: boolean) {
    chartOptions.toolbox.show = show
  }
  // 修改labelLine的长度
  changeLineLength(chartOptions, length: number) {
    chartOptions.series[0].labelLine.length = length;
  }
  // 修改labelLine2的长度
  changeLineLength2(chartOptions, length: number) {
    chartOptions.series[0].labelLine.length2 = length;
  }
}
